<template>
<footer class="footer" :style="$route.path === '/broadcast' && 'display: none'">
<!-- Follow Us -->
<section id="follow-us">
    <div class="ticker ticker-right bg-yellow loaded" data-title="Follow Us">
        <div>
            <marquee-text :duration="60">
              <h3 class="ticker-item fs-normal">Follow Us</h3>
              <span class="ticker-item performa fs-normal">Performa</span>
              <span class="ticker-item fs-normal">Follow Us</span>
              <span class="ticker-item performa fs-normal">Performa</span>
            </marquee-text>
        </div>
        
    </div>
    <div class="wrap">
        <ul class="inline-list text-extended" style="font-size: 0.85em;">
		      <li v-for="(item, index) in fields.socials" :key="'social-item-' + index">
		        <prismic-link :field="item.social_link" target="_blank" :alt="'Performa on ' + item.social_name">
		          {{ item.social_name }}
		        </prismic-link>
		      </li>
        </ul>
        <div class="mailchimp-embed">
        <p class="header-p text-condensed">{{ $prismic.richTextAsPlain(fields.mailchimp_heading_text) }}</p>
        <Mailchimp />
        </div>
    </div>
</section>
<!-- Join Us -->
<section id="join-us">
    <div v-if="$route.path !== '/'" class="ticker bg-green loaded" data-title="Join Us">
        <div>
            <marquee-text :duration="60">
              <h3 class="ticker-item fs-normal">Join Us</h3>
              <span class="ticker-item performa fs-normal">Performa</span>
              <span class="ticker-item fs-normal">Join Us</span>
              <span class="ticker-item performa fs-normal">Performa</span>
            </marquee-text>
        </div>
    </div>
    <div class="wrap" v-if="$route.path !== '/'">
        <p class="header-p text-extended">{{ $prismic.richTextAsPlain(fields.byline) }}</p>
        <prismic-link :field="fields.donate_link" class="btn btn--full" style="text-align: center">{{ fields.donate_text }}</prismic-link>
    </div>
    <div class="grid-container c3 text-smaller">
	     <div v-for="(item, index) in fields.quotes" :key="'quote-item-' + index" class="quote wrap" style="border-bottom: 0px !important;">
		     <prismic-rich-text :field="item.quote_text" class="quote-text" />
		     <prismic-rich-text :field="item.quote_author" class="artist text-right lh-1 text-condensed text-uppercase text-bold" :htmlSerializer="innerSingleParagraph"/>
	     </div>
    </div>
    <div class="wrap text-center" style="display: none;">
        <span class="btn btn--full"  :class="open ? 'active' : ''" @click="quoteClick">{{ open ? 'View Less' : 'View More' }}</span>
    </div>
</section>
<section id="footer-address">
    <div class="grid-container c3">
        <div class="logo">
            <a href="/">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1594 322" class="logo-svg">
                    <g id="Layer_2" data-name="Layer 2">
                        <g id="Layer_1-2" data-name="Layer 1">
                            <rect class="logo-bg" width="1594" height="322"></rect>
                            <path class="logo-fg" d="M61.55,258.24,92.24,63.76h77.38q32.74,0,49.26,15.87t11.35,48.1q-10.32,66-79.18,66H122.42L112.1,258.24Zm74.8-153.72L128.87,153h8.51c4.81,0,8.47,0,11-.12a57.2,57.2,0,0,0,9.67-1.42,24.88,24.88,0,0,0,9.16-3.61,25.09,25.09,0,0,0,6.19-7,29.46,29.46,0,0,0,4-11.6,30.49,30.49,0,0,0-.26-12,17.79,17.79,0,0,0-3.61-7.35q-2.33-2.57-7.74-3.74a68,68,0,0,0-9.41-1.42q-4-.26-11.48-.25Zm230.32,2.06h-60.1l-5.15,32.5h57l-6.71,42.81h-57l-5.42,33.53h60.1l-6.71,42.82H232L262.73,63.76H373.37Zm120.44,72,48.49,79.7H472.67l-35.85-74.8h-.52l-11.86,74.8H373.89L404.58,63.76h75.57q30.44,0,46.68,15t11.61,44.88a69.3,69.3,0,0,1-17,36.11A58.31,58.31,0,0,1,487.11,178.54ZM449.2,102.45l-7.74,48.49h4.9q35.07,0,38.95-24.24c.86-5,.55-9.2-.9-12.64a14,14,0,0,0-7.36-7.48,43.36,43.36,0,0,0-10.44-3.23,75.68,75.68,0,0,0-12.51-.9Zm235.74,4.13H623.81l-5.16,32.5H674.1l-6.7,42.81H611.94l-12.12,76.35H549.27L580,63.76H691.64Zm133.6-49.26a102.62,102.62,0,0,1,39.2,7.48A93.72,93.72,0,0,1,889,85.17,76.69,76.69,0,0,1,907.78,117a88,88,0,0,1,2.57,40.37q-7.47,47.21-42.55,77.25t-82,30q-46.95,0-72.48-30.17t-18-77.12a106,106,0,0,1,23.34-51.84A129.53,129.53,0,0,1,764,69.83,126.13,126.13,0,0,1,818.54,57.32ZM847,121.8q-13.8-15.48-36.24-15.48T769.66,121.8q-18.7,15.47-21.79,35.85-4.14,24.75,9.28,41.39t36.37,16.64q23,0,41.52-16.64a69.32,69.32,0,0,0,22.7-41.39Q860.83,137.28,847,121.8Zm184,56.74,48.49,79.7h-62.93l-35.85-74.8h-.52l-11.87,74.8H917.83l30.7-194.48h75.57q30.42,0,46.68,15t11.61,44.88a69.32,69.32,0,0,1-17,36.11A58.28,58.28,0,0,1,1031.06,178.54Zm-37.91-76.09-7.74,48.49h4.9q35.07,0,38.94-24.24,1.29-7.49-.9-12.64a13.91,13.91,0,0,0-7.35-7.48,43.29,43.29,0,0,0-10.45-3.23,75.47,75.47,0,0,0-12.5-.9Zm88.46,155.79,63.71-194.48h49.77l23.22,104,58-104h50.29l-1.29,194.48h-50.55l3.61-111.94h-.51l-64.48,111.94h-20.12L1166.46,146.3H1166l-34,111.94Zm389.71-33.79h-69.64l-18.82,33.79h-53.65L1434.7,63.76h55.19l42.56,194.48h-53.91Zm-7.48-38.69L1453,123.86h-.52l-30.69,61.9Z"></path>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
        <div class="credit">
	        <div class="wrap wrap-half">
	        	Site by <a href="https://special-offer.studio" target="_blank" class="so-link">Special — Offer</a>
	        </div>
        </div>
        <div class="address">
            <div class="wrap wrap-half">
                100 West 23rd St., Floor 5<br/>
                New York, NY 10011
            </div>
        </div>
    </div>
</section>
</footer>
</template>

<script>
import prismicDOM from 'prismic-dom';
import Mailchimp from '../components/Mailchimp.vue'
 
const Elements = prismicDOM.RichText.Elements;
	
const innerSingleParagraph = function (type, element, content, children) {
  if (type === Elements.paragraph) {
    return `${children.join('')}`;
  }
  return null;
}	

export default {
  name: 'Footer',
  components: {
    Mailchimp
  },
  computed: {
    open () {
      return this.$store.state.quotesOpen
    }
  },
  data () {
	  return {
		  innerSingleParagraph,
		  fields: {
			  footer_address: null,
			  byline: null,
			  socials: [],
			  quotes: [],
        mailchimp_heading_text: null,
        donate_text: null,
        donate_link: null
		  }
	  };
  },
  methods: {
	  getContent () {
		  this.$prismic.client.getSingle('footer')
		  	.then((document) => {
			  	this.fields.footer_address = document.data.footer_address;
			  	this.fields.byline = document.data.byline;
			  	this.fields.socials = document.data.socials;
			  	this.fields.quotes = document.data.quotes;
          this.fields.mailchimp_heading_text = document.data.mailchimp_heading_text;
          this.fields.donate_text = document.data.donate_text;
          this.fields.donate_link = document.data.donate_link;
        });
	  },
    quoteClick () {
      this.$store.dispatch('toggleQuotes')
    }
  },
  created () {
	  this.getContent();
  },
  mounted (){
    (function($){"use strict";$.ajaxChimp={responses:{"We have sent you a confirmation email":0,"Please enter a value":1,"An email address must contain a single @":2,"The domain portion of the email address is invalid (the portion after the @: )":3,"The username portion of the email address is invalid (the portion before the @: )":4,"This email address looks fake or invalid. Please enter a real email address":5},translations:{en:null},init:function(selector,options){$(selector).ajaxChimp(options)}};$.fn.ajaxChimp=function(options){$(this).each(function(i,elem){var form=$(elem);var email=form.find("input[type=email]");var label=form.find("label[for="+email.attr("id")+"]");var settings=$.extend({url:form.attr("action"),language:"en"},options);var url=settings.url.replace("/post?","/post-json?").concat("&c=?");form.attr("novalidate","true");email.attr("name","EMAIL");form.submit(function(){var msg;function successCallback(resp){if(resp.result==="success"){msg="We have sent you a confirmation email";label.removeClass("error").addClass("valid");email.removeClass("error").addClass("valid")}else{email.removeClass("valid").addClass("error");label.removeClass("valid").addClass("error");var index=-1;try{var parts=resp.msg.split(" - ",2);if(parts[1]===undefined){msg=resp.msg}else{var i=parseInt(parts[0],10);if(i.toString()===parts[0]){index=parts[0];msg=parts[1]}else{index=-1;msg=resp.msg}}}catch(e){index=-1;msg=resp.msg}}if(settings.language!=="en"&&$.ajaxChimp.responses[msg]!==undefined&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]){msg=$.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]}label.html(msg);label.show(2e3);if(settings.callback){settings.callback(resp)}}var data={};var dataArray=form.serializeArray();$.each(dataArray,function(index,item){data[item.name]=item.value});$.ajax({url:url,data:data,success:successCallback,dataType:"jsonp",error:function(resp,text){console.log("mailchimp ajax submit error: "+text)}});var submitMsg="Submitting...";if(settings.language!=="en"&&$.ajaxChimp.translations&&$.ajaxChimp.translations[settings.language]&&$.ajaxChimp.translations[settings.language]["submit"]){submitMsg=$.ajaxChimp.translations[settings.language]["submit"]}label.html(submitMsg).show(2e3);return false})});return this}})(jQuery);
      $('#mc-form').ajaxChimp();
  }
}
</script>
